import { lazy } from "react";
import {
  account,
  admin,
  conveyanceManagementPath,
  conveyancePath,
  dailyReportPath,
  dashboardPath,
  downloadFolderIdPath,
  downloadsPath,
  expenseAccountZonePath,
  expenseManagerPath,
  hr,
  imbursementPath,
  leavePath,
  manager,
  markAttendancePath,
  membersAttendancePath,
  membersLeavePath,
  policesPath,
  teamMembersPath,
  trainingPath,
  user,
  userPath,
  viewAttendancePath,
  vip,
} from "../utils/Constant";
import { withSuspense } from "../CommonElements/WithSuspense";
import MarkAttendanceStatusContainer from "../Pages/PunchAttendanceStatus";

const Default = lazy(() => import("../Pages/Dashboard/Default/Default"));
const ViewAttendanceUser = lazy(() => import("../Pages/Attendance"));
const ConveyancePage = lazy(() => import("../Pages/Conveyance"));
const DailyReport = lazy(() => import("../Pages/DailyReport"));
const Downloads = lazy(() => import("../Pages/Downloads"));
const ViewLeaves = lazy(() => import("../Pages/Leave/index"));
const PolicesPage = lazy(() => import("../Pages/Policies"));
const TeamMembersPage = lazy(() => import("../Pages/TeamMembers"));
const TrainingVideos = lazy(() => import("../Pages/TrainingVideos"));
const MarkAttendancePage = lazy(() => import("../Pages/PunchAttendance"));
const TeamMembersLeavePage = lazy(() => import("../Pages/TeamMembers/Leave"));
const UsersManagement = lazy(
  () => import("../Pages/EmployeeManagement/EmployeeManagement"),
);
const TeamMembersAttendancePage = lazy(
  () => import("../Pages/TeamMembers/Attendance"),
);

const TeamMembersConveyancePage = lazy(
  () => import("../Pages/TeamMembers/Conveyance"),
);

const ConveyanceManagementPage = lazy(
  () => import("../Pages/Conveyance/ConveyanceManagement"),
);
const ImbrusementPage = lazy(() => import("../Pages/Reimbrusement"));
const HRZoneUsers = lazy(() => import("../Pages/HRZone/Users"));
const EmployeeManager = lazy(() => import("../Pages/HRZone/EmployeeManager"));
const PettyCashManagerZone = lazy(
  () => import("../Pages/PettyCash/ManagerZone"),
);
const PettyCashAccountZone = lazy(
  () => import("../Pages/PettyCash/AccountZone"),
);
const PettyCashWalletHistory = lazy(
  () => import("../Pages/PettyCash/WalletHistory"),
);
const EmployeeMasterReport = lazy(
  () => import("../Pages/Reports/EmployeeReport"),
);
const ReimbursementReport = lazy(
  () => import("../Pages/Reports/ReimbursementReport"),
);

const ConveyanceReport = lazy(
  () => import("../Pages/Reports/ConveyanceReport"),
);
const EmployeeAttendanceReport = lazy(
  () => import("../Pages/Reports/EmployeeAttendanceReport"),
);

const EmployeeAttendanceCompoffSummary = lazy(
  () => import("../Pages/Reports/EmployeeAttendanceCompoffSummary")
);

const EmployeeSalaryReport = lazy(
  () => import("../Pages/Reports/EmployeeSalaryReport/index"),
);

const EmployeeLeaveReport = lazy(
  () => import("../Pages/Reports/EmployeeLeaveReport/index"),
);

const HREmployeeProbhation = lazy(
  () => import("../Pages/HRZone/EmployeeProbhation/index"),
);

const HREmployeeLeaves = lazy(
  () => import("../Pages/HRZone/EmployeeLeaves/index"),
);

const HRCompOffManagement = lazy(
  () => import("../Pages/HRZone/CompOffManagement/index")
);

const EmployeeMonthlyWiseReport = lazy(
  () => import("../Pages/Reports/EmployeeMonthlyWiseReport/index"),
);

const UsersCallingSystemRoute = lazy(
  () => import("../Pages/HRZone/UsersCallingSystemPage/index"),
);

const DailyDairyReportContainer = lazy(
  () => import("../Pages/DailyDairyReport/index"),
);

const DailyTaskListContainer = lazy(
  () => import("../Pages/DailyTaskList/index"),
);

const DepartmentListPage = lazy(() => import("../Pages/DepartmentList/index"));

const WorkDailyDairyReportContainer = lazy(
  () => import("../Pages/TeamMembers/DailyDairyReport/index"),
);

// Survey Modules Routes
const UserSurveyForms = lazy(() => import("../Pages/UserSurveyForms/index"));

const SurveyFormResponses = lazy(
  () => import("../Pages/SurveyFormResponsePage/index"),
);
const TakeSurveyContainer = lazy(() => import("../Pages/TakeSurveyPage/index"));

const SurveyFormsList = lazy(() => import("../Pages/SurveyFormsList/index"));

const SurveyFormQuestions = lazy(
  () => import("../Pages/SurveyFormQuestions/index"),
);
const SurveyFormDetails = lazy(
  () => import("../Pages/SurveyFormDetails/index"),
);

const DesignationListContainer = lazy(
  () => import("../Pages/Designation/index"),
);

//Inventory Routes
const InventoryContainer = lazy(
  () => import("../Pages/InventoryManagementPage/category"),
);
const VendoryContainer = lazy(
  () => import("../Pages/InventoryManagementPage/vendor"),
);
const ProductContainer = lazy(
  () => import("../Pages/InventoryManagementPage/product"),
);
const EmployeeInventoryAssets = lazy(
  () => import("../Pages/EmployeeInventoryAssets/index"),
);
const ProductLogsContainer = lazy(
  () => import("../Pages/InventoryManagementPage/logs"),
);

const AttendanceContainer = lazy(
  () => import("../Pages/AttendancePolicy/index"),
);
const CenterListContainer = lazy(() => import("../Pages/CenterListPage"));

// HRM Routes
const HrmReportDashboardPage = lazy(
  () => import("../Pages/Hrm/ReportDashboard/index"),
);
const HrmRequisitionPage = lazy(() => import("../Pages/Hrm/Requisition/index"));
const HrmJobOpeningsPage = lazy(() => import("../Pages/Hrm/JobOpenings/index"));
const HrmCandidatesPage = lazy(() => import("../Pages/Hrm/Candidates/index"));
const HrmCandidatesPoolPage = lazy(
  () => import("../Pages/Hrm/CandidatesPool/index"),
);
const HrmApplicationsPage = lazy(
  () => import("../Pages/Hrm/Applications/index"),
);
const HrmApplicationDetailsPage = lazy(
  () => import("../Pages/Hrm/Applications/Details"),
);
const HrmInterviewsPage = lazy(
  () => import("../Pages/Hrm/Interviews/index"),
);
const HrmOfferLettersPage = lazy(
  () => import("../Pages/Hrm/OfferLetters/index"),
);
const HrmInterviewRoundTypesPage = lazy(
  () => import("../Pages/Hrm/InterviewRoundTypes/index"),
);

export const routes = [
  // dashboard
  {
    path: dashboardPath,
    Component: <Default />,
    allowedRoles: [
      hr,
      manager,
      admin,
      user,
      vip,
      "office boy",
      account,
      "inventory mananger",
    ],
  },
  {
    path: userPath,
    Component: <UsersManagement />,
    allowedRoles: [
      hr,
      manager,
      admin,
      user,
      vip,
      "office boy",
      account,
      "inventory mananger",
    ],
  },
  {
    path: viewAttendancePath,
    Component: <ViewAttendanceUser />,
    allowedRoles: [
      hr,
      manager,
      admin,
      user,
      vip,
      "office boy",
      account,
      "inventory mananger",
    ],
  },
  {
    path: "/employee-zone/attendance-status",
    Component: withSuspense(<MarkAttendanceStatusContainer />),
    allowedRoles: [
      hr,
      manager,
      admin,
      user,
      vip,
      "office boy",
      account,
      "inventory mananger",
    ],
  },
  {
    path: markAttendancePath,
    Component: withSuspense(<MarkAttendancePage />),
    allowedRoles: [
      hr,
      manager,
      admin,
      user,
      vip,
      "office boy",
      account,
      "inventory mananger",
    ],
  },
  {
    path: leavePath,
    Component: withSuspense(<ViewLeaves />),
    allowedRoles: [
      hr,
      manager,
      admin,
      user,
      vip,
      "office boy",
      account,
      "inventory mananger",
    ],
  },
  {
    path: conveyancePath,
    Component: withSuspense(<ConveyancePage />),
    allowedRoles: [
      hr,
      manager,
      admin,
      user,
      vip,
      "office boy",
      account,
      "inventory mananger",
    ],
  },
  {
    path: dailyReportPath,
    Component: withSuspense(<DailyReport />),
    allowedRoles: [
      // hr,
      // manager,
      // admin,
      // user,
      // vip,
      // "office boy",
      // account,
      // "inventory mananger",
    ],
  },
  {
    path: teamMembersPath,
    Component: withSuspense(<TeamMembersPage />),
    allowedRoles: [manager, "Admin", "admin", account],
  },
  {
    path: conveyanceManagementPath,
    Component: withSuspense(<ConveyanceManagementPage />),
    allowedRoles: [
      hr,
      manager,
      admin,
      user,
      vip,
      "office boy",
      account,
      "inventory mananger",
    ],
  },
  {
    path: membersLeavePath,
    Component: withSuspense(<TeamMembersLeavePage />),
    allowedRoles: [manager, "Admin", "admin", account],
  },
  {
    path: membersAttendancePath,
    Component: withSuspense(<TeamMembersAttendancePage />),
    allowedRoles: [manager, "Admin", "admin", account],
  },

  {
    path: "/members/conveyance",
    Component: withSuspense(<TeamMembersConveyancePage />),
    allowedRoles: [manager, "Admin", "admin", account],
  },
  {
    path: "/members/daily-dairy-report",
    Component: withSuspense(<WorkDailyDairyReportContainer />),
    allowedRoles: [manager, "Admin", admin, account],
  },
  {
    path: trainingPath,
    Component: <TrainingVideos />,
    allowedRoles: [
      hr,
      manager,
      admin,
      user,
      vip,
      "office boy",
      account,
      "inventory mananger",
    ],
  },
  {
    path: policesPath,
    Component: withSuspense(<PolicesPage />),
    allowedRoles: [
      hr,
      manager,
      admin,
      user,
      vip,
      "office boy",
      account,
      "inventory mananger",
    ],
  },
  {
    path: downloadsPath,
    Component: withSuspense(<Downloads />),
    allowedRoles: [
      hr,
      manager,
      admin,
      user,
      vip,
      "office boy",
      account,
      "inventory mananger",
    ],
  },
  {
    path: downloadFolderIdPath,
    Component: withSuspense(<Downloads />),
    allowedRoles: [
      hr,
      manager,
      admin,
      user,
      vip,
      "office boy",
      account,
      "inventory mananger",
    ],
  },
  {
    path: imbursementPath,
    Component: withSuspense(<ImbrusementPage />),
    allowedRoles: [
      hr,
      manager,
      admin,
      user,
      vip,
      "office boy",
      account,
      "inventory mananger",
    ],
  },
  {
    path: `${expenseManagerPath}/:centerId`,
    Component: withSuspense(<PettyCashManagerZone />),
    allowedRoles: [hr, manager, admin, user, account, "inventory mananger"],
  },
  {
    path: "/account-zone/conveyance",
    Component: <TeamMembersConveyancePage />,
    allowedRoles: [admin, account],
  },
  {
    path: "/account-zone/conveyance/:id",
    Component: <TeamMembersConveyancePage />,
    allowedRoles: [admin, account],
  },
  {
    path: `/account-zone/petty-cash`,
    Component: withSuspense(<PettyCashAccountZone />),
    allowedRoles: [hr, admin, account],
  },
  {
    path: "/expense-wallet-history",
    Component: withSuspense(<PettyCashWalletHistory />),
    allowedRoles: [hr, manager, admin, user, account, "inventory mananger"],
  },
  {
    path: "/hr-zone/users",
    Component: <HRZoneUsers />,
    allowedRoles: ["Admin", admin, manager, "hr"],
  },
  // {
  //   path: "/hr-zone/user/:userId",
  //   Component: <UsersManagement />,
  //   allowedRoles: [user, "Admin", admin, manager],
  // },
  {
    path: "/hr-zone/employee-manager",
    Component: withSuspense(<EmployeeManager />),
    allowedRoles: [hr, "Admin", admin],
  },
  // {
  //   path: "/hr-zone/users",
  //   Component: withSuspense(<HRZoneUsers />),
  //   allowedRoles: ["Admin", admin, manager, hr],
  // },
  {
    path: "/user-management/user/:employeeId",
    Component: <UsersManagement />,
    allowedRoles: ["Admin", admin, manager, hr, "user", account],
  },
  {
    path: "/hr-zone/employee-manager",
    Component: withSuspense(<EmployeeManager />),
    allowedRoles: [hr, "Admin", admin, manager],
  },
  {
    path: "/hr-zone/employee-probation",
    Component: withSuspense(<HREmployeeProbhation />),
    allowedRoles: [hr, "Admin", admin, manager],
  },
  {
    path: "/hr-zone/employee-leaves",
    Component: withSuspense(<TeamMembersLeavePage />),
    allowedRoles: [hr, "Admin", admin, manager],
  },
  {
    path: "/hr-zone/comp-off",
    Component: withSuspense(<HRCompOffManagement />),
    allowedRoles: [hr, "Admin", admin],
  },
  {
    path: "/hr-zone/employee-attendance",
    Component: withSuspense(<TeamMembersAttendancePage />),
    allowedRoles: [hr, "Admin", admin, manager],
  },
  {
    path: "/hr-zone/employee-conveyance",
    Component: withSuspense(<TeamMembersConveyancePage />),
    allowedRoles: [hr, "Admin", admin],
  },
  {
    path: "/hr-zone/employee-conveyance-approved",
    Component: withSuspense(<TeamMembersConveyancePage />),
    allowedRoles: [hr, "Admin", admin],
  },
  {
    path: "/hr-zone/employee-conveyance-approved/:id",
    Component: withSuspense(<TeamMembersConveyancePage />),
    allowedRoles: [hr, "Admin", admin],
  },
  {
    path: "/reports/employee-report",
    Component: withSuspense(<EmployeeMasterReport />),
    allowedRoles: [hr, "Admin", admin, manager],
  },
  {
    path: "/reports/reimbursement-report",
    Component: <ReimbursementReport />,
    allowedRoles: [hr, "Admin", manager, admin],
  },
  {
    path: "/reports/conveyance-report",
    Component: withSuspense(<ConveyanceReport />),
    allowedRoles: [hr, "Admin", manager, admin],
  },
  {
    path: "/reports/employee-attendance-report",
    Component: withSuspense(<EmployeeAttendanceReport />),
    allowedRoles: [hr, "Admin", manager, admin],
  },
  {
    path: "/reports/employee-attendance-compoff-summary",
    Component: withSuspense(<EmployeeAttendanceCompoffSummary />),
    allowedRoles: [hr, "Admin", manager, admin],
  },
  {
    path: "/reports/employee-salary-report",
    Component: withSuspense(<EmployeeSalaryReport />),
    allowedRoles: [hr, "Admin", manager, admin],
  },
  {
    path: "/reports/employee-leave-report",
    Component: withSuspense(<EmployeeLeaveReport />),
    allowedRoles: [hr, "Admin", manager, admin],
  },
  {
    path: "/reports/employee-month-wise-report",
    Component: withSuspense(<EmployeeMonthlyWiseReport />),
    allowedRoles: [hr, "Admin", manager, admin],
  },
  {
    path: "/employee-user/:userId",
    Component: withSuspense(<UsersManagement />),
    allowedRoles: ["Admin", admin, manager, user, hr, account],
  },
  {
    path: "/calling-system/user-register",
    Component: withSuspense(<UsersCallingSystemRoute />),
    allowedRoles: ["Admin", admin, hr],
  },
  {
    path: "/survey/form-lists",
    Component: withSuspense(<SurveyFormsList />),
    allowedRoles: ["Admin", admin],
  },
  {
    path: "/admin/form/add-question/:formId",
    Component: withSuspense(<SurveyFormQuestions />),
    allowedRoles: ["Admin", admin],
  },
  {
    path: "/admin/form/details/:formId/:userId?",
    Component: withSuspense(<SurveyFormDetails />),
    allowedRoles: ["Admin", admin],
  },
  {
    path: "/department/index",
    Component: withSuspense(<DepartmentListPage />),
    allowedRoles: ["Admin", admin, hr],
  },
  {
    path: "/employee-zone/daily-dairy",
    Component: withSuspense(<DailyDairyReportContainer />),
    allowedRoles: ["admin", "hr", "manager", "user"],
  },
  {
    path: "/daily-task-list",
    Component: withSuspense(<DailyTaskListContainer />),
    allowedRoles: ["admin", "hr", "manager"],
  },
  {
    path: "/designation/index",
    Component: withSuspense(<DesignationListContainer />),
    allowedRoles: ["admin", "hr", "manager"],
  },
  {
    path: "/user/surveys",
    Component: withSuspense(<UserSurveyForms />),
    allowedRoles: ["admin", "manager", admin, "user"],
  },
  {
    path: "/form/survey/responses/:formId",
    Component: withSuspense(<SurveyFormResponses />),
    allowedRoles: ["admin", "manager", admin],
  },
  {
    path: "/take-survey/:formId",
    Component: withSuspense(<TakeSurveyContainer />),
    allowedRoles: ["admin", "manager", admin, "user"],
  },
  {
    path: "/inventory-categories",
    Component: withSuspense(<InventoryContainer />),
    allowedRoles: ["Admin", admin, "hr"],
  },
  {
    path: "/inventory-vendors",
    Component: withSuspense(<VendoryContainer />),
    allowedRoles: ["Admin", admin, "hr"],
  },
  {
    path: "/inventory-products",
    Component: withSuspense(<ProductContainer />),
    allowedRoles: ["Admin", admin],
  },
  {
    path: "/my-assets",
    Component: withSuspense(<EmployeeInventoryAssets />),
    allowedRoles: ["Admin", admin, "hr", "user", "manager", account],
  },
  {
    path: "/inventory-product-logs/:productId",
    Component: withSuspense(<ProductLogsContainer />),
    allowedRoles: ["Admin", admin],
  },
  {
    path: "/centerList",
    Component: withSuspense(<CenterListContainer />),
    allowedRoles: ["Admin", admin],
  },
  {
    path: "/attendance-policy",
    Component: withSuspense(<AttendanceContainer />),
    allowedRoles: ["Admin", admin],
  },

  // HRM Routes
  {
    path: "/hrm/report-dashboard",
    Component: withSuspense(<HrmReportDashboardPage />),
    allowedRoles: ["Admin", admin, "hr"],
  },
  {
    path: "/hrm/requisitions",
    Component: withSuspense(<HrmRequisitionPage />),
    allowedRoles: ["Admin", admin, "hr", "user"],
  },
  {
    path: "/hrm/job-openings",
    Component: withSuspense(<HrmJobOpeningsPage />),
    allowedRoles: ["Admin", admin, "hr",],
  },
  {
    path: "/hrm/candidates",
    Component: withSuspense(<HrmCandidatesPage />),
    allowedRoles: ["Admin", admin, "hr",],
  },
  {
    path: "/hrm/interview-round-types",
    Component: withSuspense(<HrmInterviewRoundTypesPage />),
    allowedRoles: ["Admin", admin, "hr"],
  },
  {
    path: "/hrm/candidates-pool",
    Component: withSuspense(<HrmCandidatesPoolPage />),
    allowedRoles: ["Admin", admin, "hr"],
  },
  {
    path: "/hrm/applications",
    Component: withSuspense(<HrmApplicationsPage />),
    allowedRoles: ["Admin", admin, "hr",],
  },
  {
    path: "/hrm/applications/:applicationId",
    Component: withSuspense(<HrmApplicationDetailsPage />),
    allowedRoles: ["Admin", admin, "hr",],
  },
  {
    path: "/hrm/interviews",
    Component: withSuspense(<HrmInterviewsPage />),
    allowedRoles: ["Admin", admin, "hr",],
  },
  {
    path: "/hrm/offer-letters",
    Component: withSuspense(<HrmOfferLettersPage />),
    allowedRoles: ["Admin", admin, "hr",],
  },
];
